// action - state management

import {
    GET_TRANSITION,
    GET_TRANSITION_TASK,GET_TRANSITION_PROGRESS
} from "./actions";

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    transitionList:[],
    task: {  },
   transitionProgressDetails:{}, 
loading:true

};


export const transitionReducer =  (state = initialState, action) => {  
  
  const { type, payload } = action;
  switch (type) {
    case GET_TRANSITION:
      return {
        ...state,
        transitionList: payload,
        loading: false,
      };
    case GET_TRANSITION_TASK:
        return{
            ...state,
            task:payload,
            
        }
    case GET_TRANSITION_PROGRESS:
        return {
            ...state,
            transitionProgressDetails:payload
        }
    
    default:
      return state;
  }
}

export default transitionReducer;